<div class="row text-left">
  <div class="col-sm-12">
    <div class="content-header">Image Cropper</div>
    <p class="content-sub-header"></p>
  </div>
</div>
<!-- Cropper starts -->
<section id="tours">
  <div class="row text-left">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4>Cropper</h4>
        </div>
        <div class="card-body">
          <div class="file-upload mb-3">
            <span class="text">Upload File : </span>
            <input id="custom-input" type="file" (change)="fileChangeEvent($event)">
          </div>
          <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 3"
            format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()" class="float-left mr-4 img-fluid"></image-cropper>

          <br>
          <div class='row justify-content-center'>
            <span class="result">
              <img [src]="croppedImage" class="rounded-circle"/>
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- Cropper Ends -->

</section>
